module.exports = __webpack_public_path__ + "img/logo.763341a2.svg";